import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Col } from 'antd'
import { chunk, map } from 'lodash'
import PropTypes from 'prop-types'

import { useQueryParams } from '../../../core/hooks'

import { PAGINATION } from '../../../common/constants'

import { unknownWordPropType } from '../../prop-types'
import {
  StyledUnknownWordsModalPagination,
  StyledUnknownWordsModalRow,
} from '../styled'

import UnknownWordCard from './unknown-word-card'

const UnknownWordsModalBody = ({ unknownWords, onClose }) => {
  const { data: menuCurationTask } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )

  const { totalUnknownWordCount } = menuCurationTask

  const {
    unknownWordsCurrentPage = PAGINATION.DEFAULT_PAGE,
    unknownWordsPageSize = PAGINATION.DEFAULT_PAGE_SIZE,
    setQueryParams,
  } = useQueryParams()

  const handleChangePagination = useCallback(
    (page, size) =>
      setQueryParams({
        unknownWordsCurrentPage:
          size !== unknownWordsPageSize ? PAGINATION.DEFAULT_PAGE : page,
        unknownWordsPageSize: size,
      }),
    [unknownWordsPageSize, setQueryParams],
  )

  return (
    <>
      {map(chunk(unknownWords, 6), (rowItems, index) => (
        <StyledUnknownWordsModalRow key={index} gutter={16}>
          {map(rowItems, unknownWord => (
            <Col span={4} key={unknownWord.id}>
              <UnknownWordCard onClose={onClose} unknownWord={unknownWord} />
            </Col>
          ))}
        </StyledUnknownWordsModalRow>
      ))}

      <StyledUnknownWordsModalPagination
        showSizeChanger
        onChange={handleChangePagination}
        onShowSizeChange={handleChangePagination}
        current={Number(unknownWordsCurrentPage)}
        total={totalUnknownWordCount}
        pageSize={Number(unknownWordsPageSize)}
        pageSizeOptions={PAGINATION.DEFAULT_PAGINATION_SIZE_OPTIONS}
      />
    </>
  )
}

UnknownWordsModalBody.propTypes = {
  unknownWords: PropTypes.arrayOf(unknownWordPropType),
  onClose: PropTypes.func.isRequired,
}

UnknownWordsModalBody.defaultProps = {
  unknownWords: [],
}

export default UnknownWordsModalBody
